export default function ApproachCard({ index, icon: Icon, title, description }) {
  const number = String(index).padStart(2, "0");
  return (
    <article className="mk-approach-card">
      <div className="mk-approach-card-top">
        <span className="mk-approach-card-num" aria-hidden="true">{number}</span>
        <div className="mk-approach-card-icon" aria-hidden="true">
          {Icon ? <Icon size={20} strokeWidth={1.9} /> : null}
        </div>
      </div>
      <h3 className="mk-approach-card-title">{title}</h3>
      <p className="mk-approach-card-desc">{description}</p>
    </article>
  );
}
